import React, { useContext, useEffect, useState } from 'react'
import {ReactComponent as PassThrough} from "../../../images/passThrough.svg"
import {ReactComponent as TierePricing} from "../../../images/tieredPricing.svg"
import {ReactComponent as FlatPricing} from "../../../images/flatPricing.svg"
import {ReactComponent as DuelPricing} from "../../../images/duelPricing.svg"
import {ReactComponent as DollarTag} from "../../../images/dollarTag.svg"
import {ReactComponent as HelpIcon} from "../../../images/helpIcon.svg"
import {ReactComponent as TickIcon} from "../../../images/tickIcon.svg"
import { IOrgPricingOptionModel } from '../../../models/AdminSettingsM/AdminSettingsModel'
import Service from '../../../services'
import { BankUserContext } from '../../../bankUserContext'
import { catchError } from '../../../utils/Utils'
import PricingOptionIcon from '../../../commonfields/PricingOptionIcon'

interface ISelectedPricingOption{
  next:Function;
  cancelButton:Function;
}

const SelectPricingOption = (props: ISelectedPricingOption) => {
  const { next,cancelButton } = props
  const [isClicked, setIsClicked] = useState(false);
  const [clickedId, setClickedId] = useState<number>(-1);
  const [selectPricingOption, setSelectPricingOption] = useState<
  IOrgPricingOptionModel[]
>([]);

const service = new Service();
const context = useContext(BankUserContext);

const getPricingOption = () => {
  const payload = {
    screen: "PricingSettings",
    sections: "getMTOptionsByMTid",
    orgId: context.bankuserDetails?.organization?.orgId,
    isJsonReturnObject: false,
  };
  service
    .getOrgProductsByPricingOption(payload)
    .then((res) => {     
      setSelectPricingOption(res?.data);
    })
    .catch((err) => catchError(err, true));
};
useEffect(() => {
  getPricingOption();
}, []);


  const data = [
    {
      id: 0,
      name: "Pass-through Plus Pricing",
      image:<PassThrough/>
    },
    {
      id: 1,
      name: "Tiered Pricing",
      image:<TierePricing/>
    },
    {
      id: 2,
      name: "Flat Pricing",
      image:<FlatPricing/>
    },
    {
      id: 3,
      name: "Duel Pricing",
      image:<DuelPricing/>
    }
  ]

  const handleClick = (id:number) => {
    setClickedId(id)
    setIsClicked(!isClicked);
  };

  const nextBtnHandler = () =>{
    next()
    
  }

  return (
    <div className="selectPricingOption">
      <div className="subContainer">
        <div className='topContainer'>
          <div className='headerSection'>
            <div></div>
            <h2 className="mainHeading">New Pricing Template</h2>
            <p className="cancel" onClick={()=>cancelButton}>Cancel</p>
          </div>
          <p className='subHeading'>select lorem ipsum dolor sit amet consectetur adipiscing</p>
        </div>
        <p className="optionHeading">Select the Pricing Option:</p>
        <div className="optionsContainer">
          {selectPricingOption.map((option:any)=>
          <div className={`option ${clickedId === option.pricingOptionId ? 'clicked' : ''}`} onClick={()=>handleClick(option.pricingOptionId)}>
            {clickedId === option.pricingOptionId ?<div className="tickIconContainer">
             <TickIcon className="tickIcon"/>
            </div> : <></>}
            <div className={`imagesContainer  ${clickedId === option.pricingOptionId? 'clickedStyle' : ''}`}>
            <div className="pricingImage"><PricingOptionIcon productName = {option.pricingOptionText}/></div>
            <DollarTag className="dollarTag"/>
            </div>
            <div className="bottomContainer">
              <p className="pricingName">{option.pricingOptionText}</p>
              <HelpIcon className="help"/>
            </div>
            
          </div>)}
        </div>
        <div className='buttonContainer'>
          <button onClick={()=>nextBtnHandler()} className="nextButton">Next</button>
        </div>
      </div>
    </div>
  )
}

export default SelectPricingOption